import React, { Component } from 'react';
import { Input } from 'antd';

class PinNumber extends Component {
	state = {
		pin1: '',
		pin2: '',
		pin3: '',
		pin4: '',
		pin5: '',
		pin6: ''
	};

	pin0 = null;
	pin1 = null;
	pin2 = null;
	pin3 = null;
	pin4 = null;
	pin5 = null;

	componentDidMount() {
		window.addEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (e) => {
		if (e.which === 8) {
			const { pin1, pin2, pin3, pin4, pin5, pin6 } = this.state;

			if (pin6 !== '') {
				this.setState({ pin6: '' }, () => this.pin4.focus());
				return;
			} else if (pin5 !== '') {
				this.setState({ pin5: '' }, () => this.pin3.focus());
				return;
			} else if (pin4 !== '') {
				this.setState({ pin4: '' }, () => this.pin2.focus());
				return;
			} else if (pin3 !== '') {
				this.setState({ pin3: '' }, () => this.pin1.focus());
				return;
			} else if (pin2 !== '') {
				this.setState({ pin2: '' }, () => this.pin0.focus());
				return;
			} else if (pin1 !== '') {
				this.setState({ pin1: '' }, () => this.pin0.focus());
				return;
			}
		}
	};

	onOk = () => {
		const { pin1, pin2, pin3, pin4, pin5, pin6 } = this.state;
		const { onOk } = this.props;
		const pin = pin1 + pin2 + pin3 + pin4 + pin5 + pin6;
		onOk(pin);
		this.setState({
			pin1: '',
			pin2: '',
			pin3: '',
			pin4: '',
			pin5: '',
			pin6: ''
		});
	};

	handleCange = (e) => {
		const { name, value } = e.target;
		const pinNumber = value
			.replace(new RegExp('[a-zA-Z-_]', 'g'), '')
			.slice(0, 1);
		this.setState(
			{
				[name]: pinNumber
			},
			() => {
				if (pinNumber.length === 1) {
					if (name === 'pin6') {
						this.onOk();
						return;
					}
					this[name].focus();
				}
			}
		);
	};

	render() {
		const { pin1, pin2, pin3, pin4, pin5, pin6 } = this.state;
		return (
			<div className="pin-input-wrapper">
				<Input
					name="pin1"
					type="password"
					value={pin1}
					ref={(el) => {
						this.pin0 = el;
						if (el) {
							el.focus();
						}
					}}
					tabIndex={0}
					onChange={this.handleCange}
				/>
				<Input
					name="pin2"
					type="password"
					value={pin2}
					tabIndex={0}
					ref={(el) => {
						this.pin1 = el;
					}}
					onChange={this.handleCange}
				/>
				<Input
					name="pin3"
					type="password"
					value={pin3}
					tabIndex={0}
					ref={(el) => {
						this.pin2 = el;
					}}
					onChange={this.handleCange}
				/>
				<Input
					name="pin4"
					type="password"
					value={pin4}
					tabIndex={0}
					ref={(el) => {
						this.pin3 = el;
					}}
					onChange={this.handleCange}
				/>
				<Input
					name="pin5"
					type="password"
					value={pin5}
					tabIndex={0}
					ref={(el) => {
						this.pin4 = el;
					}}
					onChange={this.handleCange}
				/>
				<Input
					name="pin6"
					type="password"
					value={pin6}
					tabIndex={0}
					ref={(el) => {
						this.pin5 = el;
					}}
					onChange={this.handleCange}
				/>
			</div>
		);
	}
}

export default PinNumber;
